export default __webpack_public_path__ + "1c743ac2741370d8d94b17f3fbed228d.svg";